module.exports = __webpack_public_path__ + "img/x (1).d53bebc7.png";